module.exports = __webpack_public_path__ + "img/logo1 (38).4c113a2a.jpg";